// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactCreate_container__3cgqC","form":"ContactCreate_form__32ii0"};